import React from 'react'
import cx from 'classnames'
import styles from './EmptyTaskList.sass'

export default function EmptyTaskList() {
  return (
    <div className={cx(styles.root)} data-test="empty-task-list-new">
      <h4 className={styles.title}>Congratulations!</h4>
      <p className={styles.description}>
        You have no outstanding tasks to complete.
      </p>
    </div>
  )
}
